<template>
  <div>
    <payment-schedule-details></payment-schedule-details>
  </div>
</template>
<script>

import PaymentScheduleDetails from '@/components/Payment-schedule-details'
export default {
  name: 'Payment-schedule-details-view',
  components: {PaymentScheduleDetails}
}
</script>
